














import { Mixins, Component, Prop } from "vue-property-decorator";
import { HisInformationListItem } from "../../../../domain/his";
import { ReceptionDetail } from "../../../../domain/workflow/reception";
import HisInfoListSelectDialog from "../../../his/dialogs/HisInfoListSelectDialog.vue";
import { ModelEditableMixin } from "../../../system/mixins";
import { IRestriction } from "../../../system";
import { ISingleSelectableAsynchronously } from "../../../system/selectors";
import ReceptionDialogSelector from "../../selectors/ReceptionDialogSelector.vue";

@Component({
  components: {
    ReceptionDialogSelector,
  }
})
export default class ReceptionDetailDiseaseEditor extends Mixins(ModelEditableMixin) {
  @Prop()
  hasData: boolean;

  @Prop()
  selectDialog: HisInfoListSelectDialog;

  selector: ReceptionDialogSelector;
  
  mounted(): void {
    // $refsはリアクティブではない模様.マウント後に初期化.
    this.selector = this.$refs.selector as ReceptionDialogSelector;
  }

  get dialog(): ISingleSelectableAsynchronously<string> {
    return {
      selectOption: async (_?: string, __?: { [key: string]: IRestriction }): Promise<string> => {
        const result = await this.selectDialog.show();
        if (result === undefined) {
          return null;
        }
        const source = result.data;
        return (source !== null)
          ? this.getItem(source, "DISEASE_FORMAL_NAME")
          : null;
      }
    };
  }

  private getItem(items: HisInformationListItem[], name: string): string {
    return items[0].items.filter(m => m.name === name).map(m => m.value)[0] || null;
  }

  get disease(): string {
    return this.readPropertyOrDefault(d => d.disease, null);
  }

  set disease(value: string) {
    this.writeProperty((d: ReceptionDetail) => d.disease = value);
  }

  selectDisease(): void {
    this.selector.select();
  }
}
